export default __webpack_public_path__ + "static/media/stats-illustration.e18fa5fd.svg";